import React from "react";
import cx from "classnames";
import { Button } from "components/Button";
import { useIsFetching, useIsNodeFetching } from "stores/loadingStateStore";
import s from "../Styles.module.scss";

export const PasteButton = ({
  text,
  nodeId,
  isPasteMode,
}: {
  text: string | React.JSX.Element;
  nodeId: string;
  isPasteMode: boolean;
}) => {
  const isFetching = useIsFetching();
  const isPastingIntoNode = useIsNodeFetching(nodeId);

  if (!isPasteMode && !isPastingIntoNode) return null;

  return (
    <Button
      isLoading={isPastingIntoNode}
      disabled={isFetching}
      icon={isPastingIntoNode ? undefined : "paste-light"}
      iconClassName={isPastingIntoNode ? undefined : "text-blue-300 me-1"}
      data-testid="paste-light"
      classNames={cx(
        "p-0 border-0 cursor-pointer bg-transparent text-blue-300 ms-2 text-nowrap",
        { [s.pasteButton]: !isPastingIntoNode },
        { [s.loadingButton]: isPastingIntoNode },
      )}
      color="primary"
    >
      {!isPastingIntoNode ? text : null}
    </Button>
  );
};
